import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Paper,
  Grid,
  Card,
  Switch,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import EmptyData from "../../components/EmptyData";
import {
  getDatabase,
  ref,
  get,
  child,
  onChildAdded,
  onChildChanged,
  onChildRemoved,
} from "firebase/database";
import socketService from "../../socket/SocketService";
import LongMenu from "Utils/action";
import File from "Utils/file";
import ReportGenerate from "Utils/reportGenerate";
import BatteryStatusChip from "layouts/Escort/BatteryStatusChip";
// import UserConnected from "layouts/Escort/userConnected";
// import Movement from "layouts/Escort/movement";
import UserFBK from "layouts/Escort/userFBK";
import WellBeingConnect from "layouts/Escort/WellBeingConnect";
import WellBeingMovement from "layouts/Escort/WellBeingMovement";

const VitualWellBeingHomeCheck = () => {
  const getUserState = useSelector((state) => state?.data?.getUserState);

  const [loading, setLoading] = useState(false);
  const [allData, setAllData] = useState([]);
  const [checkSuperAdmin, setCheckSuperAdmin] = useState(null);
  const [adminState, setAdminState] = useState(null);

  const [elapsedTimes, setElapsedTimes] = useState({});

  const navigate = useNavigate();

  const getData = () => {
    const getAdminInfo = JSON.parse(localStorage.getItem("user"));
    const getAdminState = getAdminInfo?.state;
    const useradmin = getAdminInfo?.superAdmin;
    setCheckSuperAdmin(useradmin);
    setAdminState(getAdminState);

    const db = getDatabase();
    const escortRef = ref(db, "virtualhomecheck");
    const userescortRef = ref(db, "users");

    const filterDataByState = (escort, userData) => {
      const escortState = userData?.state;
      if (!useradmin) {
        return escortState === getAdminState;
      } else {
        if (
          useradmin ||
          getUserState === "" ||
          getUserState === "All State" ||
          getUserState === escortState
        ) {
          return true;
        }
      }

      return escortState === getAdminState;
    };

    onChildAdded(escortRef, async (snapshot) => {
      const escort = snapshot.val();
      // console.log("onChildAdded", escort);
      const escortUserId = escort?.userId;

      if (!escortUserId || typeof escortUserId !== "string") {
        // console.warn("Invalid escortUserId:", escortUserId);
        return;
      }

      const userRef = child(ref(db, "users"), escortUserId);
      const userSnapshot = await get(userRef);
      const userData = userSnapshot.val();

      if (filterDataByState(escort, userData)) {
        await fetchFullUserObject({ ...escort, wellbeingIdd: snapshot.key }, userData);

        // console.log(escort, snapshot.key);
      }
    });

    onChildChanged(escortRef, async (snapshot) => {
      const escort = snapshot.val();
      const escortUserId = escort.userId;

      const userRef = child(ref(db, "users"), escortUserId);
      const userSnapshot = await get(userRef);
      const userData = userSnapshot.val();

      if (filterDataByState(escort, userData)) {
        // console.log(escort, snapshot.key);
      }
    });

    onChildRemoved(escortRef, async (snapshot) => {
      const escort = snapshot.val();
      const escortUserId = escort.userId;

      const userRef = child(ref(db, "users"), escortUserId);
      const userSnapshot = await get(userRef);
      const userData = userSnapshot.val();

      if (filterDataByState(escort, userData)) {
        // console.log(escort, snapshot.key);
        var removedData = escort;
        setAllData((prevData) => {
          const filteredData = prevData.filter((item) => item?.userId !== removedData?.userId);
          return filteredData;
        });
      }
    });

    onChildChanged(userescortRef, (snapshot) => {
      const userData = snapshot.val();
      // console.log("snapshot.key", userData, snapshot.key);
      setAllData((prevData) => {
        const updatedData = prevData.map((item) => {
          if (item.userId === snapshot.key) {
            return { ...item, userData: userData };
          }
          return item;
        });
        // console.log("updatedData", updatedData);
        return updatedData;
      });
    });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const now = Math.floor(Date.now() / 1000);

      setElapsedTimes(() => {
        const updated = {};

        allData.forEach((user) => {
          if (user?.startTime) {
            const elapsed = now - user.startTime;
            updated[user.userId] = elapsed > 0 ? formatTime(elapsed) : "00:00:00";
          }
        });

        return updated;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [allData]);

  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600)
      .toString()
      .padStart(2, "0");
    const mins = Math.floor((seconds % 3600) / 60)
      .toString()
      .padStart(2, "0");
    const secs = Math.floor(seconds % 60)
      .toString()
      .padStart(2, "0");
    return `${hrs}:${mins}:${secs}`;
  };

  const fetchFullUserObject = async (escort, userData) => {
    // console.log("userId ", escort);
    const db = getDatabase();
    const userRef = child(ref(db, "users"), escort?.userId);
    const userSnapshot = await get(userRef);

    const userDetails = userSnapshot.val();

    setAllData((prevData) => {
      const filteredData = [...prevData, { userData: userDetails, ...escort }];

      // console.log("filteredData", filteredData);
      const newStateFilteredData =
        getUserState === "" || getUserState === "All State"
          ? filteredData
          : filteredData.filter((item) => item?.userData?.state === getUserState);

      const uniqueData = newStateFilteredData.filter(
        (value, index, self) =>
          value.userId && index === self.findIndex((t) => t.userId === value.userId)
      );

      return uniqueData;
    });
  };

  const handleToggle = async (user, index) => {
    //console.warn(user, index, allData[index].tracking);

    // Toggle the tracking state in allData
    setAllData((prevData) => {
      const updatedData = [...prevData]; // Create a shallow copy of the previous state
      updatedData[index] = { ...updatedData[index], tracking: !updatedData[index].tracking }; // Toggle the tracking property for the specific user
      return updatedData; // Return the updated array
    });

    // Emit the updated tracking state to the server
    socketService.emit("trackingData", {
      socketId: user.userData.socketId,
      tracking: !allData[index].tracking, // Send the toggled value (the new value after toggling)
    });

    toast.info(`Tracking has been updated`, {
      autoClose: 3000,
      position: toast.POSITION.TOP_CENTER,
    });
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) {
      navigate("/authentication/sign-in");
    }
    getData();
  }, [getUserState]);

  return (
    <DashboardLayout>
      <MDBox pt={12} pb={3}>
        <Grid container spacing={6} style={{ position: "relative", minHeight: "60vh" }}>
          {loading ? (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Loading...
            </div>
          ) : (
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                  sx={{
                    textAlign: "center",
                  }}
                >
                  <ToastContainer />
                  <MDTypography
                    variant="h6"
                    color="white"
                    sx={{
                      fontWeight: "bold",
                      fontSize: "1.5rem",
                    }}
                  >
                    {checkSuperAdmin
                      ? getUserState === ""
                        ? "ALL STATE "
                        : `${getUserState?.toUpperCase()} STATE `
                      : `${adminState?.toUpperCase()} STATE `}
                    VIRTUAL WELL BEING HOME CHECK
                  </MDTypography>
                </MDBox>
                {allData.length > 0 ? (
                  <MDBox>
                    <TableContainer component={Paper}>
                      <Table aria-label="user table">
                        <TableHead>
                          <TableBody>
                            <TableCell>User Name</TableCell>
                            <TableCell align="center">Battery Indicator</TableCell>
                            <TableCell align="center">User Connected</TableCell>
                            <TableCell align="center">Location Type</TableCell>
                            <TableCell align="center">Location Address</TableCell>
                            <TableCell align="center">Location Description</TableCell>
                            <TableCell align="center">Interval</TableCell>
                            <TableCell align="center">Mode of communication</TableCell>
                            <TableCell align="center">Count Down</TableCell>
                            <TableCell align="center">Additional Information</TableCell>
                            <TableCell align="center">Staying Partner Relationship</TableCell>
                            <TableCell align="center">Partner Name</TableCell>
                            <TableCell align="center">Partner Mobile Number</TableCell>
                            <TableCell align="center">Date</TableCell>
                            <TableCell align="center">State</TableCell>
                            <TableCell align="center">Parameter</TableCell>
                            <TableCell align="center">Movement Indicator</TableCell>
                            <TableCell align="center">Tracking</TableCell>
                            <TableCell align="center">UserFBK</TableCell>
                            <TableCell align="center">Wellbeing Response</TableCell>
                            <TableCell align="center">Last Known Location</TableCell>
                            <TableCell align="center">File</TableCell>
                            <TableCell align="center">Report Generate</TableCell>

                            <TableCell align="center">Action</TableCell>
                            {allData.map((user, index) => (
                              <TableRow key={index} sx={{ height: "auto" }}>
                                <TableCell sx={{ padding: "6px" }} component="th" scope="row">
                                  <Avatar
                                    src={user?.userData?.userImage}
                                    alt={user?.userData?.userName}
                                    style={{ marginRight: "10px" }}
                                  />
                                  {user?.userData?.userName}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  <BatteryStatusChip
                                    status={(user?.userData?.BatteryIndicator * 100).toFixed(2)}
                                  />
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  {/* <UserConnected user={user?.userData} userId={user?.userId} /> */}
                                  <WellBeingConnect user={user?.userData} />
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  {user?.locationType}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  {user?.hotelName || "---"}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  {user?.hotelDescription || "---"}
                                </TableCell>

                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  {user?.Interval}
                                </TableCell>

                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  {user?.checkInType}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  <MDTypography variant="button" color="success" fontWeight="bold">
                                    {elapsedTimes[user?.userId] || "--"}
                                  </MDTypography>
                                </TableCell>

                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  {user?.additionalInfo || "--"}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  {user?.PartnerRelation || "--"}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  {user?.PartnerName} {user?.PartnerLastName}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  {user?.PartnerMobileNo || "----"}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  {new Date(user?.Date).toLocaleDateString()}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  {user?.userData?.state}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  {user?.parameter}
                                </TableCell>

                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  {/* <Movement user={user?.userData} /> */}
                                  <WellBeingMovement user={user?.userData} />
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  <Switch
                                    checked={user?.userData?.tracking}
                                    onChange={() => handleToggle(user, index)}
                                    color="primary"
                                    borderRadius="5px"
                                  />
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  <UserFBK
                                    status={user?.userData?.userFBK}
                                    userName={user?.userData?.userName}
                                  />
                                </TableCell>
                                <TableCell align="center" className="rounded" sx={{ padding: "6px" }}>
                                  {user?.userData?.Wellbeing_Response || user?.userData?.wellbeingResponse || "N/A"}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  <Link to={`/locate/${user?.userId}?userData=truck`}>
                                    <button className="btn btn-danger btn-sm">Track</button>
                                  </Link>
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  <File props={user} />
                                  {/* <Chat /> */}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  <ReportGenerate props={user?.userData} />
                                </TableCell>

                                <TableCell
                                  align="center"
                                  className="rounded"
                                  sx={{ padding: "6px" }}
                                >
                                  <LongMenu
                                    props={user}
                                    VitualWellBeingHomeCheck={true}
                                    virtualId={user?.wellbeingIdd}
                                  />
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </TableHead>
                      </Table>
                    </TableContainer>
                  </MDBox>
                ) : (
                  <EmptyData />
                )}
              </Card>
            </Grid>
          )}
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};
export default React.memo(VitualWellBeingHomeCheck);
